<ng-template #notification>
  <ng-content select="fcom-notification, [notifications]" />
</ng-template>

<div class="wrapper flex flex--column rounded-large border">
  <div class="card card-container flex">
    @if (image) {
      <div class="product-image relative">
        <fcom-image
          class="picture"
          [ratio]="imageRatio$ | async"
          [alt]="image.alt"
          [fillParent]="true"
          [imageData]="image"
          [style.minHeight.px]="notifications?.clientHeight"
        />
        <div class="notification mr-small has-image" #notifications>
          <ng-container *ngTemplateOutlet="notification"></ng-container>
        </div>
      </div>
    }

    <div class="details font-body-1 white-bg ps-medium flex-1" [ngClass]="{ 'has-image': !!image }">
      @if (!image) {
        <div class="notification mr-xsmall-x" #notifications>
          <ng-container *ngTemplateOutlet="notification"></ng-container>
        </div>
      }

      <div class="destinations font-heading-3 nordic-blue-900-text">
        <span *ngIf="title; else destinationList">{{ title }}</span>
        <ng-template #destinationList>
          <span [title]="destinations ? (destinations | finMap: 'name')?.join(' - ') : ''">
            <span
              *ngFor="let pair of destinationPairs; index as i; last as last; trackBy: trackByFn"
              class="destination ms-xsmall-r"
            >
              <span>{{ pair[0] }}</span>
              <fcom-icon class="icon-medium ms-xxsmall-x" [name]="journeyIcon" />
              <span>{{ pair[1] }}</span>
              <span *ngIf="!last">, </span>
            </span>
          </span>
        </ng-template>
      </div>
      <div class="timeline nordic-blue-900-text ms-small-t">
        {{ departureDate }}{{ arrivalDate ? ' - ' + arrivalDate : '' }}
      </div>
      <div class="passengers pr-xsmall-r" *ngIf="passengerAmount">
        {{
          (passengerAmount === 1 ? 'tripCard.passenger' : 'tripCard.passengers') | finLocalization: { passengerAmount }
        }}
      </div>
      <div class="ms-small-t" *ngIf="journeyType || bookingRef">
        <fcom-tag class="booking-ref ms-xxsmall-r" *ngIf="bookingRef">{{
          'tripCard.bookingRef' | finLocalization: { bookingRef }
        }}</fcom-tag>
        <fcom-tag class="flight-type" *ngIf="journeyType">{{
          'tripCard.tripType.' + journeyType | finLocalization
        }}</fcom-tag>
      </div>
      <span
        *ngFor="let operatingAirlineId of operatingAirlineIds"
        [attr.data-testid]="'operating-airline-' + operatingAirlineId.airlineCode"
        class="ms-xsmall-l font-body-2 overflow-hidden truncate"
      >
        {{
          'tripCard.operatingAirlineMessage'
            | finLocalization: { airlineName: operatingAirlineId.airlineName, airlineId: operatingAirlineId.id }
        }}
      </span>

      @if (!showExpandButton) {
        <div class="flex flex--space-between flex--align-center ms-small-t font-heading-4 nordic-blue-900-text">
          <div *ngIf="totalPoints || flightTotalPriceAmount">
            <span *ngIf="totalPoints" data-testid="trip-card-total-points">
              {{ 'award.points' | finLocalization: { pointsAmount: totalPoints || 0 } }}&nbsp;+
            </span>
            <span *ngIf="flightTotalPriceAmount" class="total-amount" data-testid="trip-total-amount">
              {{ flightTotalPriceAmount }}
            </span>
          </div>
          <fcom-button
            *ngIf="showStartOverButton"
            class="start-over"
            (clickBtn)="clickCta($event)"
            [icon]="{ name: SvgLibraryIcon.ARROW_BACK, position: IconPosition.RIGHT }"
            [text]="'tripCard.startOver' | finLocalization"
            [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
          />
        </div>
      }

      @if (showExpandButton) {
        <div class="expand-details flex flex--end ms-small-t">
          <button
            [attr.aria-label]="(expanded ? 'tripCard.ariaHide' : 'tripCard.ariaShow') | finLocalization"
            [attr.aria-controls]="expandContainerId"
            [attr.aria-expanded]="expanded"
            [id]="expandButtonId"
            (click)="toggleExpand($event)"
            class="font-body-1 mr-small-l nordic-blue-900-text underline medium-type"
            data-testid="trip-card-expander-toggle-button"
          >
            <span>{{ (expanded ? 'tripCard.hideFlights' : 'tripCard.showFlights') | finLocalization }}</span>
            <fcom-icon
              [class.chevron-open]="expanded"
              class="icon-medium ms-xxsmall-l chevron"
              [name]="SvgLibraryIcon.CHEVRON_DOWN"
            />
          </button>
        </div>
      }
    </div>
  </div>

  @if (showExpandButton) {
    <div>
      <fcom-expand [open]="expanded" [ariaId]="expandContainerId" [ariaLabelledBy]="expandButtonId" class="block">
        <div class="expanded-content">
          <ng-content />
        </div>
      </fcom-expand>
    </div>
  }
</div>
